module.exports = __webpack_public_path__ + "quilt2-level3.7418f8c1.png";